import type { DBUser } from "@KassaroAB/shared/types/user";
import { UserRole } from "@KassaroAB/shared/types/enums/UserRole";
import type { StoreId } from "@KassaroAB/shared/types/ids";

export const getHomePath = (user: DBUser): string => {
  if (user.role === UserRole.ADMIN) {
    return "/admin";
  }

  if (user.role === UserRole.RESELLER_ADMIN && user.resellerId) {
    return `/resellers/${user.resellerId}/overview`;
  }

  const storedStoreId = localStorage.getItem("selectedStoreId") as StoreId | null;
  if (storedStoreId) {
    return `/stores/${storedStoreId}/overview`;
  }

  return "/stores";
};
